// Type aliases only — no hand-written duplicates of the generated schema.
// See src/api/schema.d.ts (components["schemas"]) for the source of truth,
// pulled from the backend's openapi.yaml via `pnpm api:pull`.
import type { components } from "@/api/schema";

export type MarketplaceId = components["parameters"]["MarketplaceName"];
export type Connection = components["schemas"]["ConnectionStatus"];
export type ConnectionStatusCode = Connection["status"];

export const MARKETPLACE_IDS: readonly MarketplaceId[] = ["shopee", "tiktok", "lazada"];
